import { AppConfig } from '../app.config';

// Virtual Card finance amounts are tax-inclusive by default. These VC companies are the
// exception (NOT tax-inclusive, e.g. Farmers), so they keep the standard `leaseAmount + tax`
// display. The id(s) differ per environment and are configured in app.config.ts. See OR-2639.
export const isNonTaxInclusiveVcCompany = (companyDealerId: number): boolean => AppConfig.nonTaxInclusiveVcCompanyDealerIds.includes(companyDealerId);
